/**
 * Tiny module-scoped stash for "after the project tab opens, scroll the
 * project list to this task and select it". Used by the Reactivate
 * dropdown's "Im Projekt aufwecken" toast — the toast button calls
 * `setPendingTaskJump` and then `openTab` with the project's regular
 * path (no query string), so the tab manager can re-use the existing
 * tab if it's already open. ProjectPage consumes the stash on data-ready.
 *
 * Sync over async by design: `openTab` activates the tab synchronously
 * and ProjectPage's data-ready effect runs in a later tick, by which
 * time the value is already there.
 */

interface PendingTaskJump {
  projectId: string
  taskId: string
}

let pending: PendingTaskJump | null = null

export function setPendingTaskJump(projectId: string, taskId: string): void {
  pending = { projectId, taskId }
}

/**
 * Returns the pending taskId if it targets `projectId` (and clears the
 * stash), otherwise null. Stash is consumed once — a second caller for
 * the same project gets null.
 */
export function consumePendingTaskJump(projectId: string): string | null {
  if (pending && pending.projectId === projectId) {
    const taskId = pending.taskId
    pending = null
    return taskId
  }
  return null
}

/** Test-only: drops any pending jump without returning it. */
export function _resetPendingTaskJumpForTests(): void {
  pending = null
}
